import { ELEMENT_POPOVER_ACTION } from "../../../constants";

const initialState = {
  hotspotMode: { status: false, type: null },
  mapHotspotCanvas: {
    open: false,
    elementId: null,
    url: null,
  },
  popoverAction: ELEMENT_POPOVER_ACTION.LINK,
  activeHotspot: null,
  mapPreview: null,
  hotspotReorders: 0,
  fromHotspot: false,
};

export const hotspotDataSelector = (propertyId) => (state) => ({
  ...initialState,
  ...(state.hotspotData[propertyId] || {}),
});
